<template>
  <div class="chat-modal-overlay">
    <div class="loading-box" v-if="pageType!=2">
      {{pageType==0?'加载中···':'当前系统未检测到纳税人识别号，请联系管理员查询！'}}
    </div>
    <div class="chat-modal" ref="resizableBox" v-if="pageType==2">
      <div class="chat-modal-header">
        <h3>税务AI助手</h3>
        <!-- <button @click="closeModal" class="close-button">×</button> -->
      </div>
      <div class="chat-container" >
        <!-- 聊天消息显示区域 -->
        <div class="chat-messages" ref="scrollContainer" :style="{'max-height': 'calc('+currentHeight+'px - '+boxHeight+' - 50px)'}">
          <div class="tips-top">
            <div>
              您好，欢迎使用<span style="font-weight: 600;">税务AI助手</span>。有什么问题可以帮您！(*^ω^*)
            </div>
            <div>
              (可以输入您的问题，如：<span style="font-weight: 600;">增值税税负率低怎么办？</span>)
            </div>
          </div>
          <div style="padding: 10px;">
            <div v-for="(message, index) in messages" :key="index"
                 :class="{ message: true, 'user-message': message.from === 'user', 'bot-message': message.from === 'bot' }">
              <!-- 用户消息布局：头像在右，消息内容在左，时间在正下方 -->
              <template v-if="message.from === 'user'">
                <div class="message-wrapper-user user-message-wrapper">
                  <div class="message-content-user">
                    <span>{{ message.content }}</span>
                  </div>
                  <div class="avatar-container-user">
                    <img :src="require('@/assets/img/avator.png')" alt="用户头像" class="avataruser" />
                  </div>
                </div>
                <div class="message-time user-message-time">
                  {{ formatTime(message.time) }}
                </div>
              </template>
              <!-- 机器人消息布局：头像在左，消息内容在右，时间在正下方 -->
              <template v-else>
                <div class="message-wrapper bot-message-wrapper">
                  <div class="avatar-container">
                    <img :src="require('@/assets/logo.jpg')" alt="机器人头像" class="avatar" />
                  </div>
                  <div class="message-content" style="background-color: #F8F8F8;">
                    <span>{{ message.content }}</span>
                  </div>
                </div>
                <div class="message-time bot-message-time">
                  {{ formatTime(message.time) }}
                </div>
              </template>
            </div>
          </div>

        </div>
        <!-- 输入框和发送按钮 -->
        <!-- <div class="chat-input">
          <input type="text" v-model="inputMessage" placeholder="输入消息..." @keyup.enter="sendMessage" />
          <div @click="sendMessage">
            <img src="../../assets/emi.png" />
          </div>
        </div> -->
      </div>
      <div :style="{height:boxHeight}"></div>
      <div class="wrapper-box">
        <div class="deepseek-input-container">
          <div class="input-wrapper">
						<textarea ref="textarea" v-model="inputMessage" class="deepseek-input" placeholder="输入你的问题..."
                      @input="adjustHeight" @keyup.enter="sendMessage" />
            <div class="button-box">
              <div class="sel-type">
                <!-- <div :class="!incremental?'sk-box':'sk-box sk-box1'" @click="updateIncremental()">
                  <img v-if="!incremental" src="../../assets/sdskh.png" alt=""
                    srcset="" />
                  <img v-else src="../../assets/sdsk.png" alt="" srcset="" />
                  <span>深度思考</span>
                </div> -->
                <div :class="search_network=='disable'?'sk-box':'sk-box sk-box1'" @click="updateNetwork()">
                  <img v-if="search_network=='disable'" src="../../assets/lwssh.png" alt=""
                       srcset="" />
                  <img v-else src="../../assets/lwss.png" alt="" srcset="" />
                  <span>联网搜索</span>
                </div>
              </div>

              <button v-if='!loading' class="send-button" @click="sendMessage">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 2L11 13" />
                  <path d="M22 2l-7 20-4-9-9-4 20-7z" />
                </svg>
              </button>
              <div v-else @click="disconnect" class="send-pause">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chatAiApi,getTaxationAi } from '@/api/user'; // 假设路径是这样，根据实际情况修改
import { TencentSSEClient } from './services/tencentSSE'
import { getQueryString } from "@/utils/utils";
import Vue from "vue";
import { ACCESS_TOKEN } from "../../store/mutation-types";
export default {
  name: "taxationAi",
  data() {
    return {
      pageType:"0",//0加载中 1校验失败 2校验成功
      boxHeight: '150px',
      messages: [],
      newMessage: '',
      currentTime: null,
      inputMessage: '',
      loading: false,
      sseClient: new TencentSSEClient(),
      currentAssistantMessage: '', // 用于累积流式响应
      SecretId: 'AKIDNbfXCh7QbZKrCJDuOgldHk03sXzEF2e3',
      SecretKey: 'FG6j9MNBUnz145oNjsnX3PbdUAf099yd',
      appkey: 'PxhktbupzOdTPKzzYSlvgWsJomUobdxippAyHFNxFnntCZZAbkHwSPhGSmrcprIGSbuIrMPsKcXdzksqktRKIdOvWbosQHNITdSVUOgDVebotHvtjLTDYqqNCTFKpasK',
      search_network: 'disable', //enable：打开联网搜索 disable：关闭联网搜索
      incremental: false, // true 深度思考 false 回复事假
      currentHeight: 650, // 初始高度
      resizeObserver: null,
    };
  },
  watch: {
    // 监听messages变化，数据更新后滚动到底部
    messages: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true // 深度监听
    }
  },
  mounted() {
    // console.log(this.$route.query.taxNum,'mounted初始化页面')
    this.verifyTaxNum(this.$route.query.taxNum)

    this.initResizeObserver();
    let record = localStorage.getItem(`userAirecord`);
    this.messages = JSON.parse(record)||[]
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
  methods: {
    // 滚动到底部
    scrollToBottom() {
      // const container = this.$refs.scrollContainer;
      // container.scrollTop = container.scrollHeight;
      // 保障1：先获取 DOM 元素，判断是否存在（避免 undefined）
      const container = this.$refs.scrollContainer;
      if (!container) {
        console.warn('未找到 scrollContainer 元素，跳过滚动');
        return; // 直接返回，避免报错
      }

      // 保障2：用 $nextTick 确保 DOM 渲染完成（尺寸已计算）
      this.$nextTick(() => {
        // 保障3：再次判断元素是否存在（极端场景下的兜底）
        if (container && container.scrollHeight !== undefined) {
          // 执行滚动到最底部（兼容不同浏览器）
          container.scrollTop = container.scrollHeight;
          // 若上面不生效，可尝试另一种写法（针对绝对定位/固定定位的容器）
          // container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
        }
      });
    },
    initResizeObserver() {
      // 保障1：用 this.$nextTick 等待 DOM 完全渲染（$refs 才能获取到元素）
      this.$nextTick(() => {
        const target = this.$refs.resizableBox;

        // 保障2：判断 target 是否为有效 DOM 元素（避免 null/undefined）
        if (target && target.nodeType === 1) { // nodeType === 1 表示是 DOM 元素
          // 使用 ResizeObserver 监听尺寸变化
          this.resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
              this.currentHeight = Math.round(entry.contentRect.height);
            }
          });
          this.resizeObserver.observe(target); // 此时传入的是有效 DOM 元素
        } else {
          console.warn('未找到 resizableBox 元素，跳过 ResizeObserver 初始化');
        }
      });
    },
    // initResizeObserver() {
    //   // 使用ResizeObserver监听尺寸变化
    //   this.resizeObserver = new ResizeObserver(entries => {
    //     for (let entry of entries) {
    //       this.currentHeight = Math.round(entry.contentRect.height);
    //     }
    //   });
    //   this.resizeObserver.observe(this.$refs.resizableBox);
    // },
    updateNetwork() {
      if (this.search_network == 'disable') {
        this.search_network = 'enable'
      } else {
        this.search_network = 'disable'
      }
    },
    updateIncremental() {
      this.incremental = !this.incremental
    },
    // 自适应高度
    adjustHeight() {
      const textarea = this.$refs.textarea;
      textarea.style.height = "auto";
      textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`;
      this.boxHeight = `${Math.min(textarea.scrollHeight, 150)+110}px`
      // console.log(this.boxHeight)
    },
    async sendMessage() {

      if (this.newMessage.trim()!== '') {
        const userMessage = {
          from: 'user',
          content: this.newMessage,
          time: new Date()
        };
        this.messages.push(userMessage);
        this.newMessage = '';
        this.callBackendApi(userMessage.content);
      }


      if (!this.inputMessage.trim() || this.loading) return
      const userMessage = this.inputMessage
      this.messages.push({
        from: 'user',
        content: userMessage
      })
      this.inputMessage = ''
      this.loading = true
      this.currentAssistantMessage = ''
      // 添加空的AI消息用于流式更新
      this.messages.push({
        from: 'assistant',
        content: ''
      })
      try {
        let token = getQueryString("token")||Vue.ls.get(ACCESS_TOKEN)
        await this.sseClient.connect({
              // question: userMessage,
              // // 其他腾讯云需要的参数
              // session_id: this.sessionId || '',
              // stream: true,
              "session_id": this.SecretId,
              "bot_app_key": this.appkey,
              "visitor_biz_id": this.SecretId,
              "content": userMessage,
              "incremental": true,
              "streaming_throttle": 10,
              "visitor_labels": [],
              "custom_variables": {},
              "search_network": this.search_network,
              "stream": "enable",
              "workflow_status": "disable"
            },
            (data) => {
              // 处理流式数据
              // console.log('console.log')
              // console.log(data)

              if (data.type === 'reply') {
                if(data.payload.is_from_self==false){
                  this.currentAssistantMessage += data.payload.content
                  this.updateLastAssistantMessage(this.currentAssistantMessage)
                }
              }
              if (data.type === 'close') {
                this.loading = false
                // console.log('对话完成:', data)
                localStorage.setItem(`userAirecord`, JSON.stringify(this.messages))
              }
              // if (data.payload.is_final === true) {
              // 	this.loading = false
              // 	console.log('对话完成:', data)
              // }
            },
            (err) => {
              console.error('SSE错误:', err)
              this.loading = false
              this.messages.push({
                from: 'assistant',
                content: '抱歉，对话出现错误: ' + err.message
              })
            }
        )
      } catch (err) {
        console.error('连接错误:', err)
        this.loading = false
      }
    },
    updateLastAssistantMessage(content) {
      const lastMsg = this.messages[this.messages.length - 1]
      // console.log('updateLastAssistantMessage')
      // console.log(lastMsg)
      if (lastMsg.from === 'assistant') {
        this.$set(this.messages, this.messages.length - 1, {
          ...lastMsg,
          content: content
        })
      }
    },
    disconnect() {
      this.sseClient.disconnect()
      this.loading = false
      localStorage.setItem(`userAirecord`, JSON.stringify(this.messages))
    },
    // sendMessage() {
    //   if (this.newMessage.trim()!== '') {
    //     const userMessage = {
    //       from: 'user',
    //       content: this.newMessage,
    //       time: new Date()
    //     };
    //     this.messages.push(userMessage);
    //     this.newMessage = '';
    //     this.callBackendApi(userMessage.content);
    //   }
    // },
    async verifyTaxNum(taxNum){
      const res = await getTaxationAi(taxNum);
      if(res.status==200){
        this.pageType = 2
      }else{
        this.pageType = 1
      }

      // console.log(res,'获取res校验结果')
    },
    async callBackendApi(message) {
      try {
        const eventSource = await chatAiApi(message);
        let botResponseContent = '';

        const handleMessage = (event) => {
          // console.log('Received event:', event);
          // console.trace('Call stack in handleMessage');
          if (event.data === 'end') {
            const botResponse = {
              from: 'bot',
              content: botResponseContent,
              time: new Date()
            };
            // console.log('Adding bot response:', botResponse);
            this.messages.push(botResponse);
            eventSource.close();
          } else {
            botResponseContent += event.data;
          }
        };

        eventSource.onmessage = handleMessage;

        eventSource.onerror = (error) => {
          // console.error('EventSource error:', error);
          // console.trace('Call stack in onerror');
          if (eventSource.readyState === EventSource.CLOSED) {
            // console.error('EventSource connection closed unexpectedly.');
          } else if (eventSource.readyState === EventSource.CONNECTING) {
            // console.error('EventSource is trying to reconnect.');
          }
          const xhr = new XMLHttpRequest();
          xhr.open('GET', `/ai/chat?message=${encodeURIComponent(message)}`, false);
          xhr.send();
          // console.error('EventSource failed with status code:', xhr.status);
          eventSource.close();
        };
      } catch (error) {
        // console.error('Request error:', error);
        // console.trace('Call stack in callBackendApi');
      }
    },
    closeModal() {
      this.$emit('close');
    },
    formatTime(time) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      return new Intl.DateTimeFormat('zh-CN', options).format(time);
    }
  }
};
</script>

<style lang="less" scoped>
.chat-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100VW;
  height: 100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.loading-box{
  font-size: 24px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 36px;
}
.chat-modal {
  background-color: white;
  // border-radius: 5px;
  width: 100vw;
  max-width: 100vw;
  max-height: 100vh;
  height: 100vh;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  resize: both;
  overflow: hidden;
  min-width: 400px;
  min-height: 400px;
  position: relative;
}

.chat-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  height: 50px;
  // border-bottom: 1px solid #ccc;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.chat-container {
  display: flex;
  flex-direction: column;
  min-height: 100px;
  overflow: hidden;
}

.chat-messages {
  flex: 1;
  // padding: 10px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .tips-top {
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    padding: 5px 10px;
    background: linear-gradient(45deg, #e0e3ff 10%, #dff3f3 40%, #dbfff3 80%, #7baeff 100%);
    font-size: 13px;

    div {
      height: 20px;
      line-height: 20px;
    }
  }
}

.message {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.user-message {
  align-items: flex-end;
}

.bot-message {
  align-items: flex-start;
}

.message-wrapper {
  display: flex;
  // align-items: center;
  gap: 6px;
  /* 设置机器人头像和消息之间的间距 */
}

.user-message-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  // align-items: center;
  gap: 16px;
  /* 设置用户头像和消息之间的间距，与机器人的间距保持一致 */
}

.avatar-container {
  background-color: white;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.avataruser {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.message-content {
  padding: 12px 16px;
  border-radius: 10px;
  max-width: 70%;
  word-wrap: break-word;
  white-space: pre-line;
  /* 确保换行符生效 */
}

.user-message.message-content {
  background-color: #f1f8e9;
}

.message-content-user {
  background-color: #d3f0ff;
  padding: 12px 16px;
  border-radius: 10px;
  max-width: 70%;
  word-wrap: break-word;
  text-align: left;
}

.bot-message.message-content {
  background-color: #f1f8e9;
  text-align: left;
}

.message-time {
  font-size: 12px;
  color: #666;
  padding: 0 8px;
  margin-top: 4px;
}

.user-message-time {
  text-align: right;
}

.bot-message-time {
  text-align: left;
}

.chat-input {
  display: flex;
  padding: 10px;
  background-color: #ccc;
}

.chat-input input {
  flex: 1;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
}

.chat-input div {
  width: 50px;
  height: 50px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #007bff;

  img {
    width: 20px;
    height: 20px;
  }
}

.chat-input div:hover {
  background-color: #0056b3;
}

.wrapper-box {
  position: absolute;
  bottom: 0px;
  padding: 20px;
  background-color: white;
  width: 100%;
}

.deepseek-input-container {
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  width: 100%;
  margin: 0 auto;

  .input-wrapper {
    // display: flex;
    // align-items: flex-end;
    gap: 8px;
    background: white;
    border-radius: 8px;
    border: 1px solid #e1e3e6;
    transition: border-color 0.3s;

    &:focus-within {
      border-color: #007bff;
      /* DeepSeek 主题色 */
    }
  }

  .deepseek-input {
    flex: 1;
    border: none;
    resize: none;
    outline: none;
    min-height: 24px;
    max-height: 150px;
    padding: 10px;
    border-radius: 6px;
    background: transparent;
    font-size: 16px;
    line-height: 24px;
    width: 100%;

    &::placeholder {
      color: #9ca3af;
    }
  }

  .button-box {
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 10px;
    .sel-type{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sk-box {
        height: 26px;
        width: 90px;
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        background-color: #f0f0f0;
        color: #999;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        margin-right: 12px;
        img {
          width: 12px;
          height: 12px;
          margin-right: 3px;
        }
      }

      .sk-box1 {
        border: 1px solid #abcbff;
        background-color: #d7efff;
        color: #428eff;
      }
    }

  }

  .send-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 48px;
    background: linear-gradient(135deg, #007bff 0%, #007bff 100%);
    color: white;
    border: none;
    cursor: pointer;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.98);
    }
  }
  .send-pause{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 48px;
    background: linear-gradient(135deg, #007bff 0%, #007bff 100%);
    div{
      width: 10px;
      height: 10px;
      border-radius: 2px;
      background-color: #ffffff;
    }
  }
}
</style>
